import React from 'react';

import { Container } from './styles';

const HeaderPage: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default HeaderPage;
